export const SidebarDropdown = () => {
  const sidebarItems = Array.from(
    document.querySelectorAll(".sidebar__list-item")
  );
  const sidebarContainer = document.querySelector(".sidebar");

  if (!sidebarItems.length || !sidebarContainer) return;

  let activeItem = null;
  let activeDropdown = null;

  const calculateDropdownPosition = (item, dropdown) => {
    if (window.innerWidth < 768) return;
    const itemPosition = item.getBoundingClientRect().top;
    const sidebarWidth = sidebarContainer.getBoundingClientRect().width;

    dropdown.style.top = `${itemPosition}px`;
    dropdown.style.left = `${sidebarWidth}px`;
  };

  const resetDropdownPosition = (dropdown) => {
    dropdown.style.top = "";
    dropdown.style.left = "";
  };

  sidebarItems.forEach((item) => {
    const dropdown = item.querySelector(".sidebar__sublist");

    if (!dropdown) return;

    item.addEventListener("click", (e) => {
      e.preventDefault();

      const isOpening = !dropdown.classList.contains("active");

      if (activeDropdown && activeDropdown !== dropdown) {
        activeDropdown.classList.remove("active");
        resetDropdownPosition(activeDropdown);
      }

      dropdown.classList.toggle("active");

      if (isOpening) {
        activeItem = item;
        activeDropdown = dropdown;
        calculateDropdownPosition(activeItem, activeDropdown);
      } else {
        resetDropdownPosition(dropdown);
        activeItem = null;
        activeDropdown = null;
      }
    });
  });

  sidebarContainer.addEventListener("scroll", () => {
    if (!activeItem || !activeDropdown) return;
    calculateDropdownPosition(activeItem, activeDropdown);
  });
};
